<fieldset class="form-group display-inline-block full-width" [formGroup]="form">
  <ng-select [items]="sectors" multiple="true" bindLabel="name" bindValue="id" placeholder="Selecciona un sector"
    clearAllText="Clear" formControlName="idSector" (change)="sectorSelected.emit(form.get('idSector').value)"></ng-select>
</fieldset>